export default function (etat) {
    if ("INSCRITE" === etat) {
        return "Inscrite"
    } else if ("DISSOUTE" === etat) {
        return "Dissoute"
    } else if ("RADIEE" === etat) {
        return "Radiée"
    } else if ("NONCONFORME" === etat) {
        return "Non conforme"
    } else if ("RADIEE_OFFICE" === etat) {
        return "Radiée d'office"
    } else if ("RECTIFIEE_OFFICE" === etat) {
        return "Rectifiée d'office"
    }
    return null;
}

export function etatAssociationSelectItems() {
    return [
        {text: "Inscrite", value: "INSCRITE"},
        {text: "Dissoute", value: "DISSOUTE"},
        {text: "Radiée", value: "RADIEE"},
        {text: "Non conforme", value: "NONCONFORME"},

    ];
}

